/* HELDENA · heldena-scrollfix.js · v1.2 · 05.09.2026

   NE ISE YARAR
   YATAY kaydirilabilir bloklarda dikey sayfa kaydirmasini engelleyen iki ayari duzeltir.

   ⚠️ v1.2 · IKINCI SEBEP EKLENDI: scroll-snap-type mandatory
   Emin bildirdi: touch-action duzeltildikten SONRA da ust taraftan yukari
   kaydirmak icin birkac kez zorlamak gerekiyordu.
   Sebep: .nk-main-scroll uzerinde scroll-snap-type:x MANDATORY vardi.
   mandatory = "her durumda bir karta yapismak ZORUNDA". Parmakta en ufak yatay
   bilesen olunca kab hareketi sahipleniyor, kareye yapismaya calisiyor ve
   dikey hareket iptal oluyor. proximity ise yakinsa yapisir, degilse birakir.

   IKI SEBEP BIRLIKTE COZULUYOR:
     1) touch-action:pan-x  -> dikey hareketi bastan bloke eder
     2) scroll-snap mandatory -> dikey hareketi baslasa bile iptal ettirir

   KAPSAM (v1.1'den korunuyor - baska seyleri bozmamak icin)
     · gercekten YATAY tasan bloklar     (scrollWidth > clientWidth)
     · ve dikey tasmayan                 (dikey kaydirici degil)
   Sepet cekmecesi, mobil menu, dikey listeler bu filtreden gecmez - dokunulmaz.
   touch-action yalnizca 'pan-x' ise degistirilir; pan-y'ye HIC dokunulmaz.

   NOT: yama, kalici cozum degil. Bulunan her CSS'te asil deger de duzeltilmeli.
   KURAL: yatay kaydirilabilir blokta touch-action tek eksen ve snap mandatory YAZILMAZ.
*/
(function(){
  var FIXED = 'data-hld-ta-fixed';

  function fix(){
    var els = document.querySelectorAll('div,ul,ol,section,nav,figure');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute(FIXED)) continue;

      /* 1 · yatay tasiyor mu */
      if (el.scrollWidth <= el.clientWidth + 2) continue;
      /* 2 · dikey kaydirici DEGIL - oyleyse elleme */
      if (el.scrollHeight > el.clientHeight + 2) continue;

      var cs = getComputedStyle(el);
      var touched = false;

      /* 3a · touch-action: yalnizca pan-x · pan-y'ye dokunulmaz */
      if (cs.touchAction === 'pan-x') {
        el.style.setProperty('touch-action', 'pan-x pan-y', 'important');
        touched = true;
      }

      /* 3b · snap: mandatory -> proximity */
      var snap = cs.scrollSnapType || '';
      if (snap.indexOf('mandatory') > -1) {
        el.style.setProperty('scroll-snap-type', snap.replace('mandatory', 'proximity'), 'important');
        touched = true;
      }

      if (touched) el.setAttribute(FIXED, '1');
    }
  }

  function run(){ try { fix(); } catch(e){} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* gorseller yuklenince olculer degisir, tekrar bak */
  window.addEventListener('load', run);
  setTimeout(run, 900);

  /* sonradan DOM'a giren bloklar icin (quick view, app embed) */
  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function(){
      clearTimeout(t);
      t = setTimeout(run, 500);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
